// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Point } from "../../Commons/Geometry.js";
import { ChartMath } from "../Utils/ChartMath.js";
import { ToolView } from "./ToolView.js";

export let GannLineToolView = function (tool)
{
    ToolView.call(this, tool);
};

GannLineToolView.prototype = Object.create(ToolView.prototype);

GannLineToolView.prototype.IsSelectCheck = function (x, y)
{
    var scrP = this.screenPoints[0];

    return ChartMath.CalcDistanceFromPointToPoint(
                new Point(x, y),
                new Point(scrP[0], scrP[1])) <= ToolView.POINT_DX * 2;
};

GannLineToolView.prototype.DrawGannLine = function (gr, ww, highlight)
{
    var cacheTool = this.dataCacheTool;
    var mirrored = cacheTool.mirrored;
    var pen = highlight ? cacheTool.PenHighlight : cacheTool.Pen;
    var clientRect = ww.ClientRectangle;

    var screenPoints = this.screenPoints;
    var scrP = screenPoints[0];
    var x = scrP[0];
    var y = scrP[1];

    if (mirrored)
        gr.DrawLine(pen, x, y, x + (clientRect.Height - y) / Math.tan(Math.atan(1 / 1.0)), clientRect.Height);
    else
        gr.DrawLine(pen, x, y, x + y / Math.tan(Math.atan(1 / 1.0)), 0);
};

GannLineToolView.prototype.Draw = function (gr, ww, param)
{
    this.DrawGannLine(gr, ww, false);
    ToolView.prototype.Draw.call(this, gr, ww, param);
};

GannLineToolView.prototype.DrawSelection = function (gr, ww)
{
    this.DrawGannLine(gr, ww, true);
    ToolView.prototype.DrawSelection.call(this, gr, ww);
};